import { ComponentPropsWithoutRef, forwardRef } from 'react';

import { cx } from '@bolteu/clay-react';
import { ChevronRight } from '@bolteu/kalep-react-icons';
import { useBreakpointUp } from '@provider-portal/design-common/clay/hooks/useBreakpoint';

export interface StoreSelectorCurrentStoreProps extends ComponentPropsWithoutRef<'button'> {
  parentName: string;
  storeName: string;
}

export const StoreSelectorCurrentStore = forwardRef<
  HTMLButtonElement,
  StoreSelectorCurrentStoreProps
>(function StoreSelectorCurrentStore({ parentName, storeName, className, ...buttonProps }, ref) {
  const isWide = useBreakpointUp('md');

  return (
    <button
      {...buttonProps}
      ref={ref}
      id="store-selector-button"
      type="button"
      className={cx(
        'flex min-w-16 cursor-pointer items-center gap-2 rounded-lg border-0 text-static-key-dark',
        'not-hover:bg-static-key-light hover:bg-static-active-key-light active:scale-[0.975] active:duration-100 active:ease-in-out',
        'max-sm:px-4 max-sm:py-[6px] sm:max-md:px-2 sm:max-md:py-1 md:p-3',
        isWide ? 'w-full justify-between' : 'justify-center',
        className,
      )}
    >
      <div
        className={cx('flex min-w-0 flex-1 flex-col items-stretch', isWide && 'w-full max-w-[90%]')}
      >
        {isWide ? (
          <div className="w-full truncate text-left leading-4">
            <span className="bolt-font-body-m-accent text-primary">{parentName}</span>
          </div>
        ) : null}
        <div className={cx('w-full truncate leading-4', isWide && 'text-left')}>
          <span
            className={cx(
              isWide
                ? 'bolt-font-body-xs-regular text-secondary'
                : 'bolt-font-body-s-regular text-primary',
            )}
          >
            {storeName}
          </span>
        </div>
      </div>
      <div className="size-[18px] text-secondary">
        <ChevronRight className="aspect-square size-[18px] rotate-90" />
      </div>
    </button>
  );
});
